export default __webpack_public_path__ + "static/media/shopifyExtension5.afc0674f.svg";